import { t } from '@lingui/macro';

import Alert from '@decisiv/ui-components/lib/components/Alert';
import Button from '@decisiv/ui-components/lib/components/Button';
import Flex from '@decisiv/ui-components/lib/components/Flex';

import { MAX_VINS } from './schema';
import {
  WarningAction,
  WarningBody,
  WarningMessage,
  WarningTitle,
} from './styles';

interface VinsLimitWarningProps {
  onOpenBulkAdd: () => void;
}

const VinsLimitWarning = ({ onOpenBulkAdd }: VinsLimitWarningProps) => (
  <Flex marginBottom={0.5}>
    <Alert title="" intent="warning">
      <WarningBody>
        <WarningTitle>
          {t`You have reached the max amount of VINs (${MAX_VINS})`}
        </WarningTitle>
        <WarningAction>
          <Button
            type="button"
            kind="secondary"
            size="small"
            text={t`Use Bulk Add Asset`}
            onClick={onOpenBulkAdd}
          />
        </WarningAction>
        <WarningMessage>
          {t`Only the first ${MAX_VINS} VINs entered will be processed. To add more, use Bulk Add Asset.`}
        </WarningMessage>
      </WarningBody>
    </Alert>
  </Flex>
);

export default VinsLimitWarning;
